export type ColorProps =
  | 'transparent'
  | 'black'
  | 'white'
  | 'primary'
  | 'primaryDark'
  | 'primaryLight'
  | 'primaryLighter'
  | 'secondary'
  | 'secondaryDark'
  | 'secondaryLight'
  | 'error'
  | 'errorLight'
  | 'warning'
  | 'warningLight'
  | 'success'
  | 'successLight'
  | 'grayDarker'
  | 'grayDark'
  | 'grayMedium'
  | 'grayLight'
  | 'grayLighter'
  | 'grayUltraLight'
  | 'grayE7'
  | 'violet'
  | 'violetLight'
  | 'skyBlue'
  | 'skyBlueLight'
  | 'green'
  | 'pink'
  | 'pinkLight'
  | 'blue'
  | 'blueLight'
  | 'red'
  | 'tertiaryBlue'
  | 'lightBlue';

export const colors: { [key in ColorProps]?: string } = {
  transparent: 'transparent',
  black: '#333739',
  white: '#fff',
  primary: 'rgb(30, 40, 70)',
  primaryDark: '#343E85',
  primaryLight: '#7A84CB',
  primaryLighter: 'rgba(67, 78, 157, 0.15)',
  secondary: '#25BE59',
  secondaryDark: '#13c868',
  secondaryLight: 'rgba(47, 200, 99, 0.13)',
  error: '#e31837',
  errorLight: 'rgba(241, 63, 101, 0.1)',
  warning: '#F99406',
  warningLight: 'rgba(249, 148, 6, 0.15)',
  success: '#1DAB56',
  successLight: 'rgba(37, 190, 89, 0.1)',
  grayDarker: '#868E92',
  grayDark: 'rgba(0, 0, 0, 0.05)',
  grayMedium: '#A9ADB9',
  grayLight: '#CDD1D3',
  grayLighter: '#F1F1F1',
  grayUltraLight: '#F9F9F9',
  grayE7: '#E7E7E7',
  violet: '#8065e7',
  violetLight: 'rgba(128, 101, 231, 0.2)',
  skyBlue: '#00BCB1',
  skyBlueLight: 'rgba(0,188,177,0.1)',
  pink: '#df64c4',
  pinkLight: 'rgba(223, 100, 196, 0.2)',
  blue: '#552CF6',
  blueLight: 'rgba(85, 44, 246, 0.1)',
  tertiaryBlue: '#0379B2',
  lightBlue: 'rgba(191, 230, 246, 0.3)',
};
